import DataTable from '../../../components/DataTable/DataTable';
import StateBadge from '../../../components/StatesBadge/StatesBadge';
import { Alert, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getEstadoExpuestoOptions } from '../consts/periodicosTypes';
import StateBadgeConvocated from '../../../components/StatesBadge/SateBadgeConvocated';
import NoTableDataImageBO from '../../../assets/image/empty-state-establecimientos-backoffice.png';

const getFechaContratoBadge = (fechaAlta: string | Date, tabIndex?: number): React.ReactNode => {
    if (!fechaAlta) return '-';

    const fecha = new Date(fechaAlta);

    if (tabIndex === 5) {
        return <span>{fecha.toLocaleDateString()}</span>;
    }

    const hoy = new Date();
    const diffEnMs = hoy.getTime() - fecha.getTime();
    const diffEnDias = Math.floor(diffEnMs / (1000 * 60 * 60 * 24));

    let estado: 'activo' | 'presentado' | 'inactivo' | null = null;

    if (diffEnDias >= 90) {
        estado = 'inactivo';
    } else if (diffEnDias >= 60) {
        estado = 'presentado';
    } else if (diffEnDias >= 30) {
        estado = 'activo';
    }

    return estado ? (
        <StateBadge state={estado} text={fecha.toLocaleDateString()} hideIcon />
    ) : (
        <span>{fecha.toLocaleDateString()}</span>
    );
};

const ExposedGrid = ({
    items,
    filters,
    setFilters,
    isFetching,
    selectedIds,
    handleSelectEmployee,
    handleClickAction,
    showRiesgoError,
    handleSelectAllEmployed,
    tabIndex,
    getUniqueIdByTabIndex,
    getColumnWidths
}: any) => {
    const { t } = useTranslation('periodicos');
    return (
        <>
            {showRiesgoError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {t('alerts.massiveAssignment')}
                </Alert>
            )}
            <DataTable
                columnTitles={[
                    ...(tabIndex !== 5
                        ? [
                              <Checkbox
                                  checked={
                                      items?.data?.data?.length > 0 &&
                                      items?.data?.data?.every((item: any) =>
                                          selectedIds.includes(
                                              getUniqueIdByTabIndex(item, tabIndex)
                                          )
                                      )
                                  }
                                  onChange={(e) =>
                                      handleSelectAllEmployed(
                                          items?.data?.data || [],
                                          e.target.checked
                                      )
                                  }
                              />
                          ]
                        : ['']),
                    'Nombre y Apellido',
                    'Localidad',
                    'Contrato',
                    'Inicio Contrato',
                    'Riesgo',
                    ...(tabIndex === 1 ? ['Exámen Asignado'] : []),
                    ...(tabIndex === 5 ? ['Exámen', 'Reconfirmación'] : []),

                    ...(tabIndex === 2 || tabIndex === 3 ? ['Prestador'] : []),
                    ...(tabIndex === 3 ? ['Estado'] : []),
                    'Acciones'
                ]}
                columnWidths={getColumnWidths(tabIndex)}
                items={items}
                filters={filters}
                setFilters={setFilters}
                isFetching={isFetching}
                selected={items?.id}
                selectedItemFromAction={3}
                noInfoImage={NoTableDataImageBO}
                headers={[
                    ...(tabIndex !== 5
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) => (
                                      <Checkbox
                                          checked={selectedIds.includes(
                                              getUniqueIdByTabIndex(item, tabIndex)
                                          )}
                                          onChange={() => handleSelectEmployee(item)}
                                      />
                                  )
                              }
                          ]
                        : ['']),

                    {
                        type: 'data',
                        width: '20%',
                        upperLabel: (item: any) =>
                            item?.cuil ||
                            item?.empleado?.cuil ||
                            item?.examenEmpleado?.empleado?.cuil ||
                            '-',
                        lowerLabel: (item: any) => {
                            const nombre =
                                item?.nombre ||
                                item?.empleado?.nombre ||
                                item?.examenEmpleado?.empleado?.nombre ||
                                '';
                            const apellido =
                                item?.apellido ||
                                item?.empleado?.apellido ||
                                item?.examenEmpleado?.empleado?.apellido ||
                                '';
                            const nombreCompleto = `${nombre} ${apellido}`.trim();
                            return nombreCompleto || '-';
                        }
                    },

                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            item?.establecimiento?.direccion?.localidad?.nombre ||
                            item?.localidad?.nombre ||
                            item?.empleado?.establecimiento?.direccion?.localidad?.nombre ||
                            item?.examenEmpleado?.empleado?.establecimiento?.direccion?.localidad
                                ?.nombre ||
                            '-'
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            `${
                                item?.organismo?.organismoCentral?.cuit ||
                                item?.organismoCentral?.cuit ||
                                item?.empleado?.organismo?.organismoCentral?.cuit ||
                                item?.examenEmpleado?.empleado?.organismo?.organismoCentral?.cuit ||
                                item?.establecimiento?.organismo?.organismoCentral?.nombre ||
                                ''
                            }  ${
                                item?.organismo?.organismoCentral?.nombre ||
                                item?.organismoCentral?.nombre ||
                                item?.examenEmpleado?.empleado?.organismo?.organismoCentral
                                    ?.nombre ||
                                item?.empleado?.organismo?.organismoCentral?.nombre ||
                                ''
                            }`,
                        width: '15%'
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            getFechaContratoBadge(
                                item?.empleado?.organismo?.organismoCentral?.fechaInicioContrato ||
                                    item?.organismo?.organismoCentral?.fechaInicioContrato ||
                                    item?.organismoCentral?.fechaInicioContrato ||
                                    item?.examenEmpleado?.empleado?.organismo?.organismoCentral
                                        ?.fechaInicioContrato ||
                                    item?.establecimiento?.organismo?.organismoCentral
                                        ?.fechaInicioContrato,
                                tabIndex
                            ),
                        width: '7%'
                    },

                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            `${
                                item?.riesgo?.codigo || item?.examenEmpleado?.riesgo?.codigo || ''
                            } - ${
                                item?.riesgo?.descripcion ||
                                item?.examenEmpleado?.riesgo?.descripcion ||
                                ''
                            }`,
                        maxLinesBeforeEllipsis: 2,
                        showFullInfoTooltip: true
                    },

                    ...(tabIndex === 1
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) => {
                                      const descripcion =
                                          item?.examen?.descripcion ||
                                          item?.examenEmpleado?.examen?.descripcion ||
                                          item?.examenReconfirmacion ||
                                          '';
                                      return descripcion ? descripcion.toUpperCase() : '-';
                                  }
                              }
                          ]
                        : []),

                    ...(tabIndex === 5
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) => {
                                      const descripcion =
                                          item?.examenReconfirmacion ||
                                          item?.examenImportacion?.descripcion ||
                                          '';
                                      return descripcion ? descripcion.toUpperCase() : '-';
                                  }
                              },
                              {
                                  type: 'data',
                                  upperLabel: (item: any) => (
                                      <span
                                          style={{
                                              display: 'flex',
                                              justifyContent: 'center',
                                              width: '100%'
                                          }}
                                      >
                                          {item?.examenReconfirmacion ? 'SI' : 'NO'}
                                      </span>
                                  ),
                                  align: 'center'
                              }
                          ]
                        : []),

                    ...(tabIndex === 2 || tabIndex === 3
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) =>
                                      item?.prestador?.razonSocial ||
                                      item?.examenEmpleado?.prestador?.razonSocial ||
                                      '-'
                              }
                          ]
                        : []),
                    ...(tabIndex === 3
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) => (
                                      <StateBadgeConvocated
                                          hideIcon
                                          state={
                                              item?.examenEmpleado?.idEstadoEmpleadoExpuesto ??
                                              item?.estadoEmpleadoExpuesto
                                          }
                                          text={(() => {
                                              const estado = getEstadoExpuestoOptions(t).find(
                                                  (opt: any) =>
                                                      opt.id ===
                                                      (item?.examenEmpleado
                                                          ?.idEstadoEmpleadoExpuesto ??
                                                          item?.estadoEmpleadoExpuesto)
                                              );
                                              return estado?.nombre || '-';
                                          })()}
                                      />
                                  )
                              }
                          ]
                        : []),
                    {
                        type: 'action',
                        onClick: handleClickAction,
                        width: '5%'
                    }
                ]}
            />
        </>
    );
};

export default ExposedGrid;
